import { render, staticRenderFns } from "./PersistResponsavelAssociadoView.vue?vue&type=template&id=6489968f&"
import script from "./PersistResponsavelAssociadoView.vue?vue&type=script&lang=ts&"
export * from "./PersistResponsavelAssociadoView.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports